interface ComplianceRingProps {
  /** 0–100. */
  value: number;
  /** Outer diameter in px. */
  size?: number;
  /** Ring thickness in px. */
  stroke?: number;
  /** Text under the percentage, e.g. "compliant". */
  label?: string;
}

/** Colour the ring like the palette: green when healthy, rose when not. */
function ringColor(value: number): string {
  if (value >= 80) return 'var(--green)';
  if (value >= 60) return 'var(--green-deep)';
  return 'var(--rose)';
}

/** SVG donut showing a compliance percentage. Deterministic, SSR-safe. */
export default function ComplianceRing({ value, size = 132, stroke = 11, label = 'compliant' }: ComplianceRingProps) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const filled = (Math.max(0, Math.min(100, value)) / 100) * c;

  return (
    <div className="cring" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={`${value}% ${label}`}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--bg-cream)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={ringColor(value)}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${filled} ${c - filled}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div className="cring__text">
        <span className="cring__value">{value}%</span>
        <span className="cring__label">{label}</span>
      </div>
    </div>
  );
}
